/**
 * The accounts app (accounts.vecros.com) owns login — this app has no login
 * form, it only sends people there and back.
 *
 * This lived in three copies (ProtectedRoute, useAuthGate, PublicHeader), so the
 * localhost/production branch had to be kept in sync by hand. One copy now.
 */

export const accountsBaseUrl = () =>
  window.location.hostname === "localhost" ? "http://localhost:3000" : "https://accounts.vecros.com";

export const loginUrl = (returnTo = window.location.href) =>
  `${accountsBaseUrl()}/auth/login?redirectUrl=${encodeURIComponent(returnTo)}`;

/** Guard redirect: replaces the entry so Back doesn't bounce off the gate again. */
export const redirectToLogin = (returnTo) => window.location.replace(loginUrl(returnTo));

/** User-initiated sign-in: keeps the page in history to come back to. */
export const goToLogin = (returnTo) => {
  window.location.href = loginUrl(returnTo);
};
